import React from 'react';

export const confirmationDialogStyle: React.CSSProperties = {
    minWidth: 320,
};

export const confirmationDialogBodyStyle: React.CSSProperties = {
    padding: 18,
};
